




















import {Component, Vue} from 'vue-property-decorator';
import CallStaticsChartComponent from "@/components/chart/CallStaticsChartComponent.vue";
import RestcommStatics from "@/consoleapi/api/restcomm/statics";

@Component({
  components: {CallStaticsChartComponent}
})
export default class Dashboard extends Vue {
  public totalCallDuration = 0;
  public totalCallCount = 0;
  public maxCallDuration = 0;

  public staticData: any = {};

  getCallStatics(){
    const statics = new RestcommStatics();
    statics.setBearerToken(this.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)));
    statics.get(this.$cookies.get(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID)))
        .then(response => {
          console.log(response.data);
          const data = response.data;
          this.totalCallCount = data.day.total;
          this.totalCallDuration = data.day.duration;
          this.staticData = data;
        })
        .catch(error => {
          console.log(error.response);
        });
  }
  mounted(){
    this.getCallStatics();
  }
}
